import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../constant/TYPE";
import Portrait from "./portrait/Portrait";
import Landscape from "./landscape/Landscape";
import Mini from "./mini/Mini";

const ComplexCalculationKeypad = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );
  const keypad = useSelector( state => state.keypad );

  const {
    children,
    ...PROPS
  } = props;

  const Keypad = useMemo( () => {
    switch ( deviceInfo.type ) {
      case TYPE.DEVICE.PC :
        return Landscape;
      case TYPE.DEVICE.PAD :
        return TYPE.ORIENTATION.PORTRAIT === keypad.orientation ? Portrait : Landscape;
      case TYPE.DEVICE.PHONE :
        return Mini;
    }
  }, [ deviceInfo.type, keypad.orientation ] );

  return (
    <div className="keypadBox active">
      <div className="keypad_wrap">
        <Keypad { ...PROPS }>{ children }</Keypad>
      </div>
    </div>
  );

};

export default ComplexCalculationKeypad;
